import { Navigate, Outlet } from 'react-router-dom';
import { useCurrentUser } from '@/app/auth-provider';

/**
 * Manda al cliente a su portal — tarea 8.3
 *
 * ESTO NO ES SEGURIDAD Y NO DEBE CONFUNDIRSE CON ELLA. La frontera de verdad
 * está en la API: el rol CLIENTE recibe un 404 en cualquier ruta que no empiece
 * por `/portal`, y eso sigue siendo cierto aunque alguien escriba `/usuarios` en
 * la barra de direcciones.
 *
 * Lo que esto evita es una pantalla rota. Sin ello, un cliente que llegue a
 * `/panel` vería el menú lateral entero y cada tarjeta pidiendo datos a rutas
 * que le devuelven 404: una sucesión de errores donde debería estar su obra.
 *
 * NO HAY GUARDIA EN SENTIDO CONTRARIO. Quien trabaja en la empresa sí puede
 * abrir `/portal`, y es deliberado: es la única forma de comprobar qué está
 * viendo su cliente antes de decírselo por teléfono.
 */
export function SinPortal() {
  const { roleCode } = useCurrentUser();

  if (roleCode === 'CLIENT') return <Navigate to="/portal" replace />;

  return <Outlet />;
}
